/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Pets_AInputs */

const en_road_dude_faq_pets_a = /** @type {(inputs: Road_Dude_Faq_Pets_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Pick the dog or cat prompt, add a photo of your pet in the generator, and keep the motion simple. A small head turn or paw gesture works well with the window shot.`)
};

const zh_road_dude_faq_pets_a = /** @type {(inputs: Road_Dude_Faq_Pets_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。选狗狗或猫咪模板，在生成器里上传宠物照片，动作尽量简单。稍微转头或抬爪，就很适合车窗镜头。`)
};

/**
* | output |
* | --- |
* | "Yes. Pick the dog or cat prompt, add a photo of your pet in the generator, and keep the motion simple. A small head turn or paw gesture works well with the w..." |
*
* @param {Road_Dude_Faq_Pets_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_pets_a = /** @type {((inputs?: Road_Dude_Faq_Pets_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Pets_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_pets_a(inputs)
	return zh_road_dude_faq_pets_a(inputs)
});
export { road_dude_faq_pets_a as "road_dude.faq.pets.a" }